import { Component, ElementRef, EventEmitter, Output, ViewChild, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';

import { ApiError, AuthService, ButtonLoader, MessageService } from '../../../../../core';
import { periodicidadeAnual, datepickerModeYear } from '../../../../../shared';
import { Cliente } from '../../../../pessoa/cliente/cliente';
import { ClienteCrudHttpService } from '../../../../pessoa/cliente/services';
import { TypeaheadClienteComponent } from '../../../../pessoa/cliente/typeahead';
import { RepresentanteCrudHttpService } from '../../../../pessoa/representante';
import { CLIENTE_ANALISE_MERCADO_PERIODICIDADE_ANUAL, CLIENTE_ANALISE_MERCADO_PERIODICIDADE_MEDIA_MENSAL, CLIENTE_ANALISE_MERCADO_PERIODICIDADE_MENSAL } from '../../../domain/cliente-analise-mercado-periodicidade.enum';
import { ClienteAnaliseMercadoLancamento } from '../../cliente-analise-mercado-lancamento';
import { ClienteAnaliseMercadoLancamentoCreate } from '../cliente-analise-mercado-lancamento-create';
import { ClienteAnaliseMercadoLancamentoHttpService } from '../../services';
import { ClienteAnaliseMercadoLancamentoClassificacaoCreateComponent } from '../classificacao';
import { ClienteAnaliseMercadoPerspectiva, isPerspectivaClassificacao } from '../../../perspectivas/cliente-analise-mercado-perspectiva';

interface Config {
    isPerspectivaClassificacao: boolean;
}

@Component({
    selector: 'sgt-cliente-analise-mercado-lancamento-create-modal',
    templateUrl: './cliente-analise-mercado-lancamento-create-modal.component.html',
    styleUrls: ['./cliente-analise-mercado-lancamento-create-modal.component.less']
})
export class ClienteAnaliseMercadoLancamentoCreateModalComponent implements OnInit {
    config: Config;

    isRepresentante: boolean;
    entityCreate: ClienteAnaliseMercadoLancamentoCreate;
    perspectiva: ClienteAnaliseMercadoPerspectiva;

    canEditCliente: boolean;
    canEditAno: boolean;
    elModal: any;

    @Output() afterCancel = new EventEmitter<any>();
    @Output() afterCreate = new EventEmitter<ClienteAnaliseMercadoLancamento>();

    @ViewChild('form') form: NgForm;
    @ViewChild('typeaeadCliente') typeaeadCliente: TypeaheadClienteComponent;
    @ViewChild('classificacaoCreate') classificacaoCreate: ClienteAnaliseMercadoLancamentoClassificacaoCreateComponent;
    // Datepicker
    datePickerMode = datepickerModeYear.id;
    datePickerPeriodicidade = periodicidadeAnual.id;

    // Periodicidades
    lancamentoPeriodicidadeAnual = CLIENTE_ANALISE_MERCADO_PERIODICIDADE_ANUAL;
    lancamentoPeriodicidadeMediaMensal = CLIENTE_ANALISE_MERCADO_PERIODICIDADE_MEDIA_MENSAL;
    lancamentoPeriodicidadeMensal = CLIENTE_ANALISE_MERCADO_PERIODICIDADE_MENSAL;

    constructor(private el: ElementRef,
                private authService: AuthService,
                private messageService: MessageService,
                private clienteCrudHttpService: ClienteCrudHttpService,
                private representanteCrudHttpService: RepresentanteCrudHttpService,
                private clienteAnaliseMercadoLancamentoHttpService: ClienteAnaliseMercadoLancamentoHttpService) { }

    ngOnInit() {
        this.isRepresentante = this.authService.isRepresentante();

        this.createModal();
    }

    /** Cria o modal */
    private createModal() {
        this.elModal = jQuery(this.el.nativeElement).find('.modal') as any;
        this.elModal
            .on('show.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('shown.bs.modal', (e: any) => {
                this.setConfig();

                if (this.canEditCliente) {
                    this.typeaeadCliente?.setFocus();
                } else if (this.config.isPerspectivaClassificacao) {
                    this.classificacaoCreate?.setFocusGrupo();
                }

                e.stopPropagation();
            })
            .on('hide.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('hidden.bs.modal', (e: any) => {
                e.stopPropagation();
            });
    }

    private setConfig() {
        this.config = {
            isPerspectivaClassificacao: isPerspectivaClassificacao(this.perspectiva?.id ?? null)
        }
    }

    /**
     * Abre o modal para inserir um novo lançamento de análise de mercado
     *
     * @param idCliente ID do cliente da análise
     * @param ano ano da análise
     */
    insert(perspectiva: ClienteAnaliseMercadoPerspectiva, idCliente: number, ano: number = null) {
        this.elModal.modal({keyboard: false, backdrop: 'static'});

        this.entityCreate = new ClienteAnaliseMercadoLancamentoCreate(perspectiva.id, idCliente, ano);
        this.perspectiva = perspectiva;

        // Se informado o cliente carregamos ele e não permitimos editá-lo
        if (this.entityCreate.idCliente) {
            this.canEditCliente = false;
            this.loadCliente(idCliente);
        } else { // Se não, permite editar o cliente para poder selecioná-lo
            this.canEditCliente = true;
        }

        // Se informado o ano não permitimos editá-lo
        if (this.entityCreate.ano) {
            this.entityCreate.ano = ano;
            this.canEditAno = false;
        } else {
            this.canEditAno = true;
        }
    }

    /** Reseta o form e fecha o modal */
    private close() {
        this.elModal.modal('hide');
        this.entityCreate = null;
    }

    cancel() {
        this.close();
        this.afterCancel.emit();
    }

    /** Ao selecionar o cliente */
    onSelectCliente(cliente: Cliente) {
        if (cliente) {
            this.entityCreate.idCliente = cliente.id;
            this.findRepresentanteCliente(cliente.idRepresentante);
        } else {
            this.onClearCliente();
        }
    }

    /** Ao remover o cliente */
    onClearCliente() {
        this.entityCreate.idCliente = null;
        this.entityCreate.representante = null;
    }

    /** Carrega o cliente */
    private loadCliente(idCliente: number) {
        this.clienteCrudHttpService.load(idCliente)
            .subscribe(
                cliente => {
                    this.entityCreate.cliente = cliente;
                    this.onSelectCliente(this.entityCreate.cliente);
                },
                (() => {
                    this.entityCreate.idCliente = null;
                    this.entityCreate.cliente = null;
                })
            );
    }

    /** Pesquisa o representante do cliente */
    private findRepresentanteCliente(idRepresentante: number) {
        this.representanteCrudHttpService.find(idRepresentante)
            .subscribe(
                representante => this.entityCreate.representante = representante,
                () => this.entityCreate.representante = null
            );
    }

    /** Verifica se está tudo válido para criar o lançamento na análise de mercado */
    private isValid(): boolean {
        // Classificações
        if (this.config.isPerspectivaClassificacao) {
            if (!this.classificacaoCreate?.isValid()) {
                return false;
            }
        }

        if (!this.form.valid) {
            this.messageService.info('Para criar o lançamento é necessário informar corretamente todos os campos destacados em vermelho', 'Informação');
            return false;
        }

        return true;
    }

    /** Cria o lançamento da análise de mercado */
    create() {
        if (this.isValid()) {
            const btn = new ButtonLoader('#btnClienteAnaliseMercadoLancamentoCreateModal');
            btn.loading('Adicionando');

            this.clienteAnaliseMercadoLancamentoHttpService.create(this.entityCreate)
                .subscribe(
                    entity => {
                        btn.reset();
                        this.messageService.success('', 'Lançamento criado com sucesso na análise de mercado');
                        this.afterCreate.emit(entity);

                        this.close();
                    },
                    (error: ApiError) => {
                        btn.reset();
                        this.messageService.error(error.message, 'Erro ao criar o lançamento na análise de mercado', error);
                    }
                );
        }
    }
}
